import React from "react";
import { AppConfig, AppConfigContext } from "./contexts/AppConfigContext";
import { AlertProvider } from "./contexts/AlertContext";
import AssignmentsList from "./components/assignmentsPage/AssignmentsPage";
import { Route, Routes, Navigate } from "react-router-dom";
import Home from "./Home";
import { AuthProvider } from "./contexts/AuthContext";
import { useAuth } from "./contexts/controllers/useAuth";
import LoginPage from "./components/auth/LoginPage";
import { ConfirmationProvider } from "./contexts/ConfirmationContext";
import { SSEProvider } from "./contexts/SSEContext";

const PrivateRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default function App() {
  const [appConfig, setAppConfig] = React.useState<AppConfig>(undefined!);

  React.useEffect(() => {
    const env = (import.meta.env.VITE_APP_ENV || "").toLowerCase();
    document.title = env === "dev" ? "Microstor - SPB (Dev)" : "Microstor - SPB";

    fetch(`${window.location.origin}/config.json`)
      .then((response) => response.json())
      .then((data) => setAppConfig(data))
      .catch((error) => console.error("Erreur lors du chargement de la configuration :", error));
  }, []);

  return (
    <AppConfigContext.Provider value={appConfig}>
      {appConfig !== undefined ? (
        <AlertProvider>
          <ConfirmationProvider>
            <AuthProvider>
              <SSEProvider>
                <Routes>
                  <Route path="/login" element={<LoginPage />} />
                  <Route
                    path="/"
                    element={
                      <PrivateRoute>
                        <Home />
                      </PrivateRoute>
                    }
                  >
                    <Route
                      path="assignments"
                      element={
                        <PrivateRoute>
                          <AssignmentsList />
                        </PrivateRoute>
                      }
                    />
                  </Route>
                </Routes>
              </SSEProvider>
            </AuthProvider>
          </ConfirmationProvider>
        </AlertProvider>
      ) : null}
    </AppConfigContext.Provider>
  );
}
